// PR 51 · P51-B2 (owner review 21-Oct-2026) — a 316(a) a REVIEW engagement still holds opens in the generic form dialog
// read-only: this notice (why, a link to R316(a) on the review screen) and the N/A action (the reason is asked, ISA 230 — why).
// The sign-off bar stays in the dialog. The server refuses a content save there (409 FORM_316A_NOT_FOR_REVIEW).
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { toErrMsg } from "@/lib/api";
import { askPrompt } from "@/lib/appDialog";
import { useI18n } from "@/contexts/I18nContext";
import { FAR_ROUTE } from "@/lib/farForms";

export default function Legacy316aNotice({ engagementId, formId, isNA, onChanged }) {
  const { lang, t } = useI18n();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    let reason = "";
    if (!isNA) {
      reason = ((await askPrompt(t("formsPage.naReasonPrompt"), t("legacy316a.naReasonDefault"))) || "").trim();
      if (reason.length < 3) { toast.error(t("formsPage.naReasonRequired")); return; }
    }
    setBusy(true);
    try {
      const r = await api.post(`/forms/${engagementId}/${formId}/na`, { is_not_applicable: !isNA, reason });
      toast.success(isNA ? t("formsPage.markedApplicable") : t("formsPage.markedNa"));
      if (onChanged) onChanged(!isNA, r.data?.na_reason || "");
    } catch (e) {
      toast.error(toErrMsg(e, t("common.failed")));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-1 flex flex-wrap items-start gap-2 rounded border border-amber-300 bg-amber-50 p-2 text-[12px] text-amber-900 dark:bg-amber-950/40 dark:text-amber-200"
         data-testid="form-316a-review-readonly" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Lock className="mt-0.5 h-3 w-3 flex-none" />
      <div className="min-w-0 flex-1" data-testid="form-316a-review-banner">{t("legacy316a.banner")}</div>
      <Button size="sm" variant="outline" className="h-7" onClick={() => navigate(FAR_ROUTE)} data-testid="form-316a-open-r316a">
        {t("legacy316a.openR316a")}
      </Button>
      <Button size="sm" className="h-7" onClick={toggle} disabled={busy} data-testid="form-316a-na">
        {isNA ? t("legacy316a.markApplicable") : t("legacy316a.markNa")}
      </Button>
    </div>
  );
}
